import classNames from 'classnames'
import { observer } from 'mobx-react-lite'
import {
  SelectFieldMultiList,
  type SelectFieldMultiListProps,
} from 'shared/ui/Select/SelectMultiListField/SelectMultiListField.tsx'
import { ChipWithAvatar } from 'entities/Phone/ui/AssignNumberCommon/ui/ChipWithAvatar/ChipWithAvatar.tsx'
import { MultiSelectDropdownContent } from 'entities/Phone/ui/AssignNumberCommon/ui/NewInboxContent/MultiSelectDropdownContent.tsx'
import { type MultiSelectMembersStore } from 'entities/Users/ui/MultiSelectMembers/store/MultiSelectMembersStore.ts'
import styles from './styles.module.scss'

export const MultiSelectMembers = observer(
  ({
    labelProps,
    store,
  }: {
    labelProps: SelectFieldMultiListProps['labelProps']
    store: MultiSelectMembersStore
  }) => {
    const { membersDropdownItems, setSelectedMember, viewSelectedMembers, deleteSelectedMember } =
      store

    return (
      <SelectFieldMultiList
        withInitialSearch
        maxVisibleChips={5}
        maxChipsHeight={224}
        ChipComponent={ChipWithAvatar}
        labelProps={labelProps}
        dropdownProps={{
          textFieldProps: {
            className: classNames(styles.selectMembersPadding, {
              [styles.empty]: !viewSelectedMembers.length,
            }),
          },
          PopperProps: {
            modifiers: [
              {
                name: 'offset',
                options: {
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  offset: ({ reference }) => {
                    return [0, -reference.height - 8]
                  },
                },
              },
            ],
          },
        }}
        items={membersDropdownItems}
        selectedItems={viewSelectedMembers}
        onDelete={deleteSelectedMember}
        onSelect={setSelectedMember}
        fullWidth
        customComponent={() => (
          <MultiSelectDropdownContent
            ChipComponent={ChipWithAvatar}
            items={membersDropdownItems}
            selectedItems={viewSelectedMembers}
            onSelect={setSelectedMember}
            onDelete={deleteSelectedMember}
            shouldShowNotFoundText
            withEmailSearch
          />
        )}
      />
    )
  }
)
